import { Component, Input, OnInit } from '@angular/core';
import { PostDO } from '../../common/data-objects/PostDO';

@Component({
  selector: 'app-blog-post-thumbnail',
  templateUrl: './blog-post-thumbnail.component.html',
  styleUrls: ['./blog-post-thumbnail.component.scss']
})
export class BlogPostThumbnailComponent implements OnInit {
  @Input() postData: PostDO;

  constructor() { }

  ngOnInit() {
  }

  get postLink(): string[] {
    return [this.postData.slug];
  }

  get postImage(): string {
    return `url(${this.postData.featuredImageSizes && this.postData.featuredImageSizes.mediumLarge ? this.postData.featuredImageSizes.mediumLarge : 'assets/logo.svg'})`;
  }
}
